__turbopack_context__.v({
  "infoBox": "GK7ffG_infoBox",
});
